import { Box } from "@mui/material";
import Lottie from "lottie-react";

import moneyStack from "./money_stack.json";

export const MoneyLoading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Lottie
        animationData={moneyStack}
        loop={true}
        style={{ width: 200, height: 200 }}
      />
    </Box>
  );
};
